<template>
  <b-overlay :show="loading">
    <div class="formBoder">
    <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
      <b-form @submit.prevent="handleSubmit(submitData)" @reset.prevent="reset" autocomplete="off">
        <b-row>
          <b-col lg="12" md="12" sm="12" xs="12">
            <ValidationProvider name="Site Name" vid="site_name" rules="required" v-slot="{ errors }">
              <b-form-group
                label-cols-sm="12"
                label-for="site_name"
              >
              <template v-slot:label>
                Site Name <span class="text-danger">*</span>
              </template>
                <b-form-input
                  id="site_name"
                  v-model="form.site_name"
                  placeholder="Enter Site Name"
                  :state="errors[0] ? false : (valid ? true : null)"
                ></b-form-input>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col lg="12" md="12" sm="12" xs="12">
            <ValidationProvider name="Site Navbar Text" vid="site_navbar_text" rules="required" v-slot="{ errors }">
              <b-form-group
                label-cols-sm="12"
                label-for="site_navbar_text"
              >
              <template v-slot:label>
                Site Navbar Text <span class="text-danger">*</span>
              </template>
                <b-form-input
                  id="site_navbar_text"
                  v-model="form.site_navbar_text"
                  placeholder="Enter Site Navbar Text"
                  :state="errors[0] ? false : (valid ? true : null)"
                ></b-form-input>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col lg="12" md="12" sm="12" xs="12">
            <ValidationProvider name="Site Logo" vid="logo">
              <b-form-group
                label-for="logo"
                slot-scope="{ valid, errors }"
              >
              <template v-slot:label>
                Site Logo <br/>
                <img v-if="logoUrl" :src="logoUrl" class="mr-2" height="70" alt="Site Logo">
                <img v-if="!logoUrl && form.logo" :src="form.logo" class="mr-2" height="70" alt="Site Logo">
              </template>

              <b-form-file
                class="mt-3"
                id="logo"
                v-on:change="changeLogo"
                accept="image/*"
                ref="file"
                :state="errors[0] ? false : (valid ? true : null)"
                ></b-form-file>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <!-- <b-col lg="4" md="4" sm="12" xs="12">
            <ValidationProvider name="Is Active" vid="active" rules="required" v-slot="{ errors }">
              <b-form-group
                label-cols-sm="12"
                label-for="active"
              >
              <template v-slot:label>
                Is Active <span class="text-danger">*</span>
              </template>
                <b-form-checkbox
                  id="active"
                  v-model="form.active"
                  placeholder="Enter Is Active"
                  :state="errors[0] ? false : (valid ? true : null)"
                  switch>
                </b-form-checkbox>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </b-form-group>
            </ValidationProvider>
          </b-col> -->
        </b-row>
      <div class="row mt-3">
        <div class="col-sm-3"></div>
        <div class="col text-right">
            <b-button type="submit" variant="primary" class="mr-2">{{ SaveButton }}</b-button>
            &nbsp;
            <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-1')">Cancel</b-button>
        </div>
      </div>
     </b-form>
    </ValidationObserver>
    </div>
  </b-overlay>
</template>
<script>
import RestApi, { apiBaseURL } from '@/config'

export default {
  props: ['editItem'],
  components: {
  },
  data () {
    return {
      SaveButton: this.editItem ? 'Update' : 'Save',
      form: {
        id: '',
        site_name: '',
        site_navbar_text: '',
        logo: ''
      },
      errors: [],
      valid: null,
      loading: false,
      logoUrl: ''
    }
  },
  created () {
    if (this.editItem) {
      this.form = JSON.parse(this.editItem)
      console.log('this.form', this.form)
    }
  },
  methods: {
    changeLogo (event) {
      const inputFile = event.target.files[0]
      const inputFilePath = event.target.value

      const reader = new FileReader()
      if (inputFile.size < 5242880) {
        const allowedExtensions = /(\.jpg|\.jpeg|\.bmp|\.gif|\.png)$/i

        if (!allowedExtensions.exec(inputFilePath)) {
          alert('File type should be jpg/jpeg/png/gif!', 'error')
          return false
        }

        reader.onloadend = () => {
          this.logoUrl = reader.result
        }
        reader.readAsDataURL(inputFile)
        this.form.logo = inputFile
      } else {
        alert('File size should be maximus 5MB!', 'error')
      }
    },
    async submitData () {
      this.loading = true
      let result = ''
      var formData = new FormData()
      Object.keys(this.form).map(key => {
        formData.append(key, this.form[key])
      })
      if (this.form.id) {
        result = await RestApi.postData(apiBaseURL, 'admin/ajax/update_site_info_data', formData)
      } else {
        result = await RestApi.postData(apiBaseURL, 'admin/ajax/store_site_info_data', formData)
      }
      this.loading = false
      if (result.success) {
        this.$emit('loadList', true)
        this.$toast.success({
          title: 'Success',
          message: result.message
        })
        this.$bvModal.hide('modal-1')
        this.getSiteInoData()
      } else {
        this.$refs.form.setErrors(result.errors)
      }
    },
    async getSiteInoData () {
      this.loading = true
      const result = await RestApi.getData(apiBaseURL, 'admin/ajax/get_active_site_info_data')
      this.loading = false
      if (result.success) {
        this.$store.dispatch('setSiteInfo', result.data)
      }
    }
  }
}
</script>
<style>
 .formBoder {
    border: 1px solid;
    margin: 5px;
    padding: 35px;
    font-size: 13px
 }
 .input-group-text {
   height: 30.5px!important;
 }
</style>
